// Конкретный файл вместо barrel'а compob2b-libs: модуль читается до bootstrap
// и в node-спеках — barrel утащил бы весь Angular-граф (ловушка из CLAUDE.md).
import {AppLocale, DEFAULT_LOCALE, isSupportedLocale, SUPPORTED_LOCALES} from 'compob2b-libs/src/lib/i18n/locale';

/**
 * UI-локаль админки — язык ИНТЕРФЕЙСА (меню, формы, кнопки, тосты).
 * К этому же ключу привязана и локаль ДАННЫХ (AdminLocaleService):
 * один переключатель RU|EN управляет интерфейсом и языком справочных
 * данных (overlay переводов, read-only-гейт). Гейт aiTranslation живёт
 * в AdminLocaleService: при выключенной фиче данные всегда ru.
 *
 * Модель локали общая с libs (AppLocale/SUPPORTED_LOCALES; состав списка —
 * из environment.contentLocales через setSupportedLocales). Добавление
 * контент-языка = правка `environment.<стенд>.ts: contentLocales`, без кода.
 * Перевод ИНТЕРФЕЙСА для него (опционально): словарь
 * environments/translations.<xx>.ts + assets/i18n/<xx>.json + ветки в
 * i18n-init.ts (registerLocaleData, TUI-язык) — без них content-язык получает
 * ru-интерфейс. AdminLocaleService подхватит локаль автоматически (валидация
 * через UI_LOCALES).
 */
export type AdminUiLocale = AppLocale;
export const UI_LOCALES = SUPPORTED_LOCALES;
export const DEFAULT_UI_LOCALE: AdminUiLocale = DEFAULT_LOCALE;
export const ADMIN_UI_LOCALE_KEY = 'compo.admin.ui.locale';

/**
 * Синхронно читает UI-локаль из localStorage. Зовётся до bootstrap Angular
 * (main.ts) и из провайдер-фабрик, поэтому без DI — голый localStorage.
 */
export function readUiLocale(): AdminUiLocale {
  try {
    const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(ADMIN_UI_LOCALE_KEY) : null;
    return raw !== null && isSupportedLocale(raw) ? raw : DEFAULT_UI_LOCALE;
  } catch {
    return DEFAULT_UI_LOCALE;
  }
}

export function writeUiLocale(locale: AdminUiLocale): void {
  if (!isSupportedLocale(locale)) {
    return;
  }
  try {
    localStorage.setItem(ADMIN_UI_LOCALE_KEY, locale);
  } catch {
    // приватный режим/запрет storage — молча остаёмся на текущей локали
  }
}
